/**
 * InfoBubble components.
 *
 * open close clicable InfoBubble
 */

(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      const triggerButton = element.querySelector('[data-trigger]');
      const bubble = element.querySelector('[data-bubble]');
      const calcBubblePos = () => {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const bubbleRect = bubble.getBoundingClientRect();
        const triggerRect = triggerButton.getBoundingClientRect();
        const overflowLeft = triggerRect.x + (triggerRect.width - bubbleRect.width) / 2 - 16;
        const overflowRight = viewportWidth - 16
          - (triggerRect.x + (triggerRect.width + bubbleRect.width) / 2);

        if (overflowLeft < 0) {
          element.style.setProperty('--_delta-overflow', `${overflowLeft * -1}px`);
        } else if (overflowRight < 0) {
          element.style.setProperty('--_delta-overflow', `${overflowLeft * -1}px`);
        } else {
          element.style.setProperty('--_delta-overflow', 0);
        }
      };

      calcBubblePos();

      window.addEventListener('resize', () => {
        window.requestAnimationFrame(() => {
          calcBubblePos();
        });
      }, false);

      if (!element.classList.contains('-click')) {
        return;
      }

      const closeButton = element.querySelector('[data-close]');

      const clickOutsideHandle = (event) => {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === bubble.parentNode) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        // eslint-disable-next-line no-use-before-define
        toggleState(false);
      };

      const toggleState = (state) => {
        element.setAttribute('aria-expanded', state);

        if (state) { // open
          calcBubblePos();
          document.addEventListener('click', clickOutsideHandle);
        } else { // close
          document.removeEventListener('click', clickOutsideHandle);
        }
      };

      triggerButton.addEventListener('click', () => {
        toggleState(!(element.getAttribute('aria-expanded') === 'true'));
      });

      closeButton.addEventListener('click', () => {
        toggleState(false);
      });
    });
  }

  Drupal.behaviors.infoBubble = {
    attach: () => {
      if (document.querySelectorAll('.js-info-bubble').length !== 0) {
        init(document.querySelectorAll('.js-info-bubble'));
      }
    },
  };
})();
